import debounce from 'lodash/debounce';
import isNan from 'lodash/isNaN';
import { trackButtonClick, trackComponentClick, trackComponent, DEBOUNCE_TIMEOUT, trackMediaPLayerEvent, } from '../../utils/snowplow-utils';
function snowplowPlugin() {
    var player = this;
    const handlePlayBtnClick = debounce(() => {
        const btnName = 'Video Player: Play';
        trackButtonClick(btnName, btnName);
    }, DEBOUNCE_TIMEOUT);
    const handleMuteBtnClick = debounce(() => {
        const btnName = 'Video Player: Mute';
        trackButtonClick(btnName, btnName);
    }, DEBOUNCE_TIMEOUT);
    const handleFullScreenBtnClick = debounce(() => {
        const btnName = 'Video Player: FullScreen';
        trackButtonClick(btnName, btnName);
    }, DEBOUNCE_TIMEOUT);
    const handleVolumeChange = debounce(() => {
        const ctrlName = 'Video Player: Volume Slider';
        trackComponent('Slider', ctrlName, 'Volume Change', ctrlName);
    }, DEBOUNCE_TIMEOUT);
    const handleShareLinkBtnClick = debounce(() => {
        const btnName = 'Video Player: Share Link';
        trackButtonClick(btnName, btnName);
    }, DEBOUNCE_TIMEOUT);
    const handleRestartSegmentBtnClick = debounce(() => {
        const btnName = 'Video Player: Restart Segment';
        trackButtonClick(btnName, btnName);
    }, DEBOUNCE_TIMEOUT);
    const handleCloseBtnClick = debounce(() => {
        const btnName = 'Video Player: Close';
        trackButtonClick(btnName, btnName);
    }, DEBOUNCE_TIMEOUT);
    const handleProgressBarClick = debounce(() => {
        const cmpName = 'Video Player: Progress';
        trackComponentClick('Progress Bar', cmpName, cmpName);
    }, DEBOUNCE_TIMEOUT);
    const handleMetadataViewBtnClick = debounce(() => {
        const btnName = 'Video Player: Metadata View Toggle';
        trackButtonClick(btnName, btnName);
    }, DEBOUNCE_TIMEOUT);
    const handleLoopSegmentBtnClick = debounce(() => {
        const btnName = 'Video Player: Loop Segment';
        trackButtonClick(btnName, btnName);
    }, DEBOUNCE_TIMEOUT);
    const logMissingControlError = (el) => {
        if (!el) {
            console.error("Video Player Control wasn't found");
        }
    };
    let playBtn = null;
    let muteBtn = null;
    let fullScreenBtn = null;
    let shareLinkBtn = null;
    let restartSegmentBtn = null;
    let closeVideoBtn = null;
    let progressCtrl = null;
    let metadataViewBtn = null;
    let loopSegmentBtn = null;
    player.one('ready', function () {
        const el = player.el_;
        playBtn = el.querySelector('.vjs-play-control');
        logMissingControlError(playBtn);
        playBtn === null || playBtn === void 0 ? void 0 : playBtn.addEventListener('click', handlePlayBtnClick);
        muteBtn = el.querySelector('.vjs-mute-control');
        logMissingControlError(muteBtn);
        muteBtn === null || muteBtn === void 0 ? void 0 : muteBtn.addEventListener('click', handleMuteBtnClick);
        fullScreenBtn = el.querySelector('.vjs-fullscreen-control');
        logMissingControlError(fullScreenBtn);
        fullScreenBtn === null || fullScreenBtn === void 0 ? void 0 : fullScreenBtn.addEventListener('click', handleFullScreenBtnClick);
        shareLinkBtn = el.querySelector('.share-link.vjs-control');
        logMissingControlError(shareLinkBtn);
        shareLinkBtn === null || shareLinkBtn === void 0 ? void 0 : shareLinkBtn.addEventListener('click', handleShareLinkBtnClick);
        restartSegmentBtn = el.querySelector('.restart-loop.vjs-control');
        logMissingControlError(restartSegmentBtn);
        restartSegmentBtn === null || restartSegmentBtn === void 0 ? void 0 : restartSegmentBtn.addEventListener('click', handleRestartSegmentBtnClick);
        closeVideoBtn = el.querySelector('.close-video.vjs-control');
        logMissingControlError(closeVideoBtn);
        closeVideoBtn === null || closeVideoBtn === void 0 ? void 0 : closeVideoBtn.addEventListener('click', handleCloseBtnClick);
        progressCtrl = el.querySelector('.vjs-progress-control.vjs-control');
        logMissingControlError(progressCtrl);
        progressCtrl === null || progressCtrl === void 0 ? void 0 : progressCtrl.addEventListener('click', handleProgressBarClick);
        metadataViewBtn = el.querySelector('.metadata-view-button.vjs-control');
        logMissingControlError(metadataViewBtn);
        metadataViewBtn === null || metadataViewBtn === void 0 ? void 0 : metadataViewBtn.addEventListener('click', handleMetadataViewBtnClick);
        loopSegmentBtn = el.querySelector('.loop-segment-btn.vjs-control');
        logMissingControlError(loopSegmentBtn);
        loopSegmentBtn === null || loopSegmentBtn === void 0 ? void 0 : loopSegmentBtn.addEventListener('click', handleLoopSegmentBtnClick);
        player.on('volumechange', handleVolumeChange);
    });
    player.on('dispose', function () {
        playBtn === null || playBtn === void 0 ? void 0 : playBtn.removeEventListener('click', handlePlayBtnClick);
        muteBtn === null || muteBtn === void 0 ? void 0 : muteBtn.removeEventListener('click', handleMuteBtnClick);
        fullScreenBtn === null || fullScreenBtn === void 0 ? void 0 : fullScreenBtn.removeEventListener('click', handleFullScreenBtnClick);
        shareLinkBtn === null || shareLinkBtn === void 0 ? void 0 : shareLinkBtn.removeEventListener('click', handleShareLinkBtnClick);
        restartSegmentBtn === null || restartSegmentBtn === void 0 ? void 0 : restartSegmentBtn.removeEventListener('click', handleRestartSegmentBtnClick);
        closeVideoBtn === null || closeVideoBtn === void 0 ? void 0 : closeVideoBtn.removeEventListener('click', handleCloseBtnClick);
        progressCtrl === null || progressCtrl === void 0 ? void 0 : progressCtrl.removeEventListener('click', handleProgressBarClick);
        metadataViewBtn === null || metadataViewBtn === void 0 ? void 0 : metadataViewBtn.removeEventListener('click', handleMetadataViewBtnClick);
        loopSegmentBtn === null || loopSegmentBtn === void 0 ? void 0 : loopSegmentBtn.removeEventListener('click', handleLoopSegmentBtnClick);
    });
    const metadata = player.options().__metadata__;
    const buildEventMetadataPayload = (title, eventType) => {
        const playerDuration = player.duration();
        const duration = isNan(playerDuration) ? null : playerDuration;
        const currentTime = player.currentTime();
        const startTime = metadata.asset.startTime;
        const endTime = metadata.asset.endTime;
        return {
            title,
            duration,
            currentTime,
            startTime,
            endTime,
            eventType,
        };
    };
    // Covering snowplow mediatracking plugin DefaultEvents:
    // [ "ready", "pause", "play", "seeked", "ratechange", "volumechange", "ended", "fullscreenchange", "percentprogress" ]
    player.on([
        'ready',
        'pause',
        'play',
        'seeked',
        'ratechange',
        'ended',
        'fullscreenchange',
        'percentprogress',
    ], (e) => {
        trackMediaPLayerEvent(buildEventMetadataPayload(metadata.title, e.type));
    });
    const handleMediaElVolumeChange = debounce(() => {
        trackMediaPLayerEvent(buildEventMetadataPayload(metadata.title, 'volumechange'));
    }, DEBOUNCE_TIMEOUT);
    player.on(['volumechange'], handleMediaElVolumeChange);
}
videojs.registerPlugin('snowplow', snowplowPlugin);
